import axiosInstance, { getNewCancelToken } from '@/services/_AxiosInstance';

/**
 * Service untuk mengelola Bunker Location
 * @namespace BunkerLocationSvc
 */
export default {
  /**
   * Mendapatkan semua data Bunker Location
   * @function getBunkerLocation
   * @return {Promise} Promise yang berisi response dari server
   */
  getBunkerLocation: async (params) => {
    const { data } = await axiosInstance.get('/master/bunker_location', {
      params: {
        ...params,
      },
      cancelToken: getNewCancelToken(),
    });
    return data;
  },
  /**
   * Mendapatkan data Bunker Location berdasarkan ID
   * @function getBunkerLocationById
   * @param {number} id - ID dari Bunker Location yang ingin di dapatkan
   * @return {Promise} Promise yang berisi response dari server
   */
  getBunkerLocationById: async (id) => {
    const { data } = await axiosInstance.get(`/master/bunker_location/${id}`, {
      cancelToken: getNewCancelToken(),
    });
    return data;
  },
  /**
   * Membuat data Bunker Location baru
   * @function createBunkerLocation
   * @param {object} data - Data yang ingin di buat
   * @return {Promise} Promise yang berisi response dari server
   */
  createBunkerLocation: async (bunkerLocationData) => {
    const { data } = await axiosInstance.post('/master/bunker_location', bunkerLocationData, {
      cancelToken: getNewCancelToken(),
    });
    return data;
  },
  /**
   * Mengupdate data Bunker Location yang sudah ada
   * @function updateBunkerLocation
   * @param {number} id - ID dari Bunker Location yang ingin di update
   * @param {object} data - Data yang ingin di update
   * @return {Promise} Promise yang berisi response dari server
   */
  updateBunkerLocation: async (id, bunkerLocationData) => {
    const { data } = await axiosInstance.put(`/master/bunker_location/${id}`, bunkerLocationData, {
      cancelToken: getNewCancelToken(),
    });
    return data;
  },
  /**
   * Menghapus data Bunker Location yang sudah ada
   * @function deleteBunkerLocation
   * @param {number} id - ID dari Bunker Location yang ingin di hapus
   * @return {Promise} Promise yang berisi response dari server
   */
  deleteBunkerLocation: async (id) => {
    const { data } = await axiosInstance.delete(`/master/bunker_location/${id}`, {
      cancelToken: getNewCancelToken(),
    });
    return data;
  },
};
